import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { ToastService } from '@web/shared/ui';
import { AdminValidationSettingsApiService } from '../api/services/admin-validation-settings-api.service';
import { AdminValidationSettingsFormData } from '../models/admin-validation-settings-form-data';
import { AdminValidationSettingsUpdateRequest } from '../api/requests/admin-validation-settings-update.request';

@Injectable({
  providedIn: 'root',
})
export class AdminValidationSettingsDataSourceService {
  private readonly validationSettingsApi = inject(
    AdminValidationSettingsApiService,
  );
  private readonly toast = inject(ToastService);

  public fetchSettingsFormData(): Observable<AdminValidationSettingsFormData> {
    return this.validationSettingsApi
      .fetchSettings({ skipByLoading: true })
      .pipe(
        map(
          (response) =>
            new AdminValidationSettingsFormData({
              nipBlackList: response.nipBlackList,
            }),
        ),
      );
  }

  public updateSettingsByFormData(
    data: AdminValidationSettingsFormData,
  ): Observable<void> {
    return this.validationSettingsApi
      .updateSettings(
        new AdminValidationSettingsUpdateRequest({
          nipBlacklist: data.nipBlackList,
        }),
      )
      .pipe(
        tap(() => {
          this.toast.show((builder) =>
            builder
              .initSuccess('Konfiguracja walidacji została zaktualizowana.')
              .build(),
          );
        }),
      );
  }
}
